import { getGetDetailedUserQueryKey, getGetUsersQueryKey } from '@/generated/client/users/users';
import type { GetUsersParams } from '@/generated/model';

type UserListParams = Omit<GetUsersParams, 'offset' | 'limit'>;

export const userKeys = {
  lists: () => getGetUsersQueryKey(),
  infiniteList: (params: UserListParams, pageSize: number) =>
    [...getGetUsersQueryKey(), 'infinite', params, pageSize] as const,
  detail: (userId: number) => getGetDetailedUserQueryKey({ userid: userId }),
};
